import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'simplebar-react/dist/simplebar.min.css';
import './App.scss';
import Modal from './components/atoms/modal/modal';
import Layout from './components/layout/layout';
import { useAxiosInterceptor } from './config/axios-interceptor';
import { useAppDispatch } from './reducers';
import { getAccount } from './reducers/authentication.reducer';
import AppRoutes from './routes';

dayjs.extend(relativeTime);

const App = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  useAxiosInterceptor();

  useEffect(() => {
    dispatch(getAccount());
  }, [dispatch]);

  return (
    <div>
      <div
        className={`app-content ${
          location.pathname.includes('/login') ||
          location.pathname.includes('/change-password') ||
          location.pathname.includes('/reset-password')
            ? 'auth'
            : ''
        }`}
      >
        <Layout>
          <AppRoutes />
        </Layout>
      </div>

      <ToastContainer
        hideProgressBar={true}
        closeButton={false}
        draggable={false}
        position="bottom-right"
        className="toastify-container"
        toastClassName="toastify-toast"
      />
      <Modal />
    </div>
  );
};

export default App;
